export function LoginPage({ login }) {
  return (
    <div className="sidecontent LoginPage">
      <input placeholder="Username" id="username-input"></input>
      <input placeholder="Password" type="password" id="password-input"></input>

      <button
        onClick={() => {
          const username = document.getElementById("username-input").value;
          const password = document.getElementById("password-input").value;
          login(username, password);
        }}
      >
        Log in
      </button>
    </div>
  );
}
